<!-- /src/components/layouts/FullWidth.vue -->
<template>
  <div class="layout layout--full">
    <div class="layout--content--container">
      <header class="layout--header">
        <slot name="header"></slot>
      </header>
      <div class="layout--content">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>

export default {

  
}
</script>

<style scoped>

.layout {
  /* min-height: 100vh; */
  display: grid;
  /* user-select: none; */

  &--content {
    height: 100%;

    &--container {
      display: grid;
      grid-template-rows: auto 1fr;
      grid-row-gap: 1rem;
      /* margin-top: var(--itemSpacing-lg); */
    }
    
  }

  &--full {
    width: 100%;
    max-width: var(--desktop-width);
    margin: 0 auto var(--itemSpacing-lg) auto;
    position: relative;
    height: 100%;
    /* justify-content: space-between; */
    padding: 0 5%;
    
    @media(--tablet) {
      padding: 0 var(--itemSpacing-lg);
    }
  }

  &--header {
    margin-top: var(--itemSpacing);

    &--has-interactions {
      .layout--header {
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 1rem;

        @media(--desktop) {
          grid-template-columns: 1fr auto;
        }
      }
    }
  }

  &__content {
    align-self: stretch;
    justify-self: center;
    max-width: var(--desktop-width);
    width: 100%;
    padding: 0 var(--itemSpacing);

    &__columns {

      @media (--tablet) {
        display: grid;
        grid-template-columns: 18rem auto;
        height: 100%;
        grid-template-rows: 100%;
      }

      &__left {
        /* grid-column-start: span 0; */

        background-color: rgba(#002f6c, 0.07);
        border-radius: 0 0 var(--borderRadiusSmall) var(--borderRadiusSmall);

        @media (--tablet) {
          border-radius: 0;
        }

        &Interior {
          padding: 2.2rem var(--itemSpacing) 1rem var(--itemSpacing);
        }
      }

      &__right {
        /* grid-column-start: span 1; */

        &Interior {
          padding-top: 2rem;

          @media (--tablet) {
            padding-top: 0;
          }
        }
      }
    }
  }
}

.layout--session .layout--content--container {
  grid-row-gap: 2rem;
}

.landing--page .layout--header {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 1rem;

  @media(--tablet) {
    grid-template-columns: 1fr auto;
  }
}

</style>
